const Drawer = {
  baseStyle: {
    content: {
      boxShadow: 'none'
    }
  }
};

export default Drawer;
